import React from 'react';

const LoadingAnimation = ({ size = 'md', className = '' }) => {
    // Tamanhos otimizados e aumentados para a nova girafa
    const sizes = {
        sm: 'w-48 h-48',   // 192x192px (era 144x144px)
        md: 'w-64 h-64',   // 256x256px (era 192x192px) - PADRÃO
        lg: 'w-80 h-80',   // 320x320px (era 288x288px)
        xl: 'w-96 h-96'    // 384x384px (mantido)
    };

    return (
        <div className={`${sizes[size]} ${className} flex items-center justify-center`}>
            <img
                src="/images/loading.gif"
                alt="Loading..."
                className="w-full h-full object-contain"
            />
        </div>
    );
};

export default LoadingAnimation;
